export default __webpack_public_path__ + "WilfriedPelligrino.aea254b.jpg";